import React from 'react';
import { ITaxonomy } from '../../../../models/interfaces/ITaxonomy';
import { resolveActivityIcon } from '../../../Global/Icons/Icons';

type ActivityIconProps = {
	activity: ITaxonomy;
};

const ActivityIcon: React.FC<ActivityIconProps> = ({ activity }) => {
	const IconComponent = resolveActivityIcon(activity.icon_slug, activity.slug);

	return <IconComponent />;
};

export default ActivityIcon;
